import { Pipe, PipeTransform } from '@angular/core';
import {RedeemStatus} from "../types/cs.types";

@Pipe({
  name: 'redeemStatusTranslate'
})
export class RedeemStatusTranslatePipe implements PipeTransform {

  transform(value: RedeemStatus): string {
    switch (value) {
      case RedeemStatus.pending:
        return 'Ausstehend';
      case RedeemStatus.in_process:
        return 'In Bearbeitung';
      case RedeemStatus.send:
        return 'Gesendet';
      case RedeemStatus.completed:
        return 'Erhalten';
      default:
        return 'Unbekannt';
    }
  }

}
